import storage from '@/renderer/scripts/utils/storage/index';
import { StoreKey } from './StoreKey';

interface IStorageCache {
  getCache(key: StoreKey): any;

  set(key: StoreKey, value: unknown): void;

  get<T>(key: StoreKey): T;

  del(key: StoreKey): void;
}

/**
 * 缓存storage，减少IO读取过程
 * @constructor
 * @usage
 *
 */
class StorageCache<T> implements IStorageCache {
  private _storageRef;
  private _cacheData = new Map<StoreKey, unknown>();

  constructor() {
    this._storageRef = storage;
    this._init();
  }

  getCache<T>(key: StoreKey): T {
    const cacheData = this._cacheData.get(key);
    if (cacheData === undefined) {
      // console.log(`log check 命中失败 key: ${key} | value ${cacheData}`);
      return this._storageRef.get(key);
    }
    // console.log(`log check 命中缓存 key: ${key} | value ${cacheData}`);
    return cacheData as any as T;
  }

  private _init() {
    const storageRef = this._storageRef;
    const uploadSetting = storageRef.get(StoreKey.UPLOAD_TRANSFER_SETTING);
    const downloadSetting = storageRef.get(StoreKey.DOWNLOAD_TRANSFER_SETTING);
    this._cacheData.set(StoreKey.DOWNLOAD_TRANSFER_SETTING, downloadSetting);
    this._cacheData.set(StoreKey.UPLOAD_TRANSFER_SETTING, uploadSetting);
  }
  set(key: StoreKey, value: unknown): void {
    this._cacheData.set(key, value);
    this._storageRef.set(key, value);
  }

  get<T>(key: StoreKey): T {
    return this._storageRef.get(key);
  }

  del(key: StoreKey): void {
    this._cacheData.delete(key);
    this._storageRef.del(key);
  }
}

export const storageCache = new StorageCache();
